'use strict';

var enumerate = require('../../lib/enumerate');

module.exports = enumerate([
  'BANK_CHOSEN',
  'REDIRECT_PAGE_REACHED'
], 'ideal:');
